
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/loja/busca",
      function () {
        return require("private-next-pages/loja/busca.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/loja/busca"])
      });
    }
  